import React from "react";
import styles from "./Icons.module.css";

const BlankIcon = () => {
  return <div className={styles.blankIcon}></div>;
};

export default BlankIcon;
